import { IconName } from '@ng-icons/core';
import { AccessLevel } from '../../services/asset-service/types';

interface AccessLabelMap {
  icon: IconName;
}

export const ACCESS_LABEL_MAP: Record<AccessLevel, AccessLabelMap> = {
  Public: {
    icon: 'tablerWorld',
  },
  'Internal ADB': {
    icon: 'tablerBuildings',
  },
  Restricted: {
    icon: 'tablerLock',
  },
  Proprietary: {
    icon: 'tablerShieldLock',
  },
};
